import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { useMutation } from '@apollo/client';
import { editColor } from '../../../../../graph/procedures';
import { InvertColors } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import PopupColorSelectMenu from '../shared/PopupColorSelectMenu';

const ColorType = ({ procedureId, color }: { procedureId: number; color?: string }) => {
  const classes = useStyles();

  const [setColor] = useMutation(editColor);

  const handleSelect = async (nextColor: string | null) => {
    try {
      await setColor({ variables: { id: procedureId, color: nextColor } });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className={classes.wrapper}>
      <PopupColorSelectMenu
        selectedColor={color ?? null}
        editable
        onSelect={handleSelect}
        renderTrigger={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <InvertColors style={{ color: color || 'inherit' }} />
          </IconButton>
        )}
      />
    </div>
  );
};

const useStyles = makeStyles(theme =>
  createStyles({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  })
);

export default ColorType;
